module.exports = __webpack_public_path__ + "img/default-account-image.66915dd7.png";